export default {
	tabs: ["Vklad", "História"],
	History: {
		tabs: ["Prehľad", "Úspech", "Odmietnuť"]
	},
	AccountAmount: "Suma účtu",
	ContactCustomerService: "Kontaktovať zákaznícky servis",
	NoCustomerService: "Zákaznícky servis Zaneprázdnený",
	tips: "Predtým, ako pristúpite k ďalšiemu hodnoteniu, odošlite predchádzajúce hodnotenie!"
};
